import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-full border-t border-zinc-200 bg-white py-6 px-6 sm:px-0">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-y-4">
        <div className="text-sm text-zinc-500 text-center sm:text-left">
          © {new Date().getFullYear()} Talos. All rights reserved.
        </div>
        <div className="flex gap-6">
          <Link 
            to="/blog"
            className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors"
          >
            Blog
          </Link>
          <Link
            to="https://docs.google.com/document/d/1PCjWVTyUp-w97REHJ0j9WpFTCX1Dxvmmdvu7accVku4/edit?usp=drive_link"
            target="_blank"
            className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors"
          >
            Privacy
          </Link>
          <Link
            to="https://docs.google.com/document/d/1izzA4jpa2tMExzjxdjQxDpEy7XrocWhM9dTARYnnPp4/edit?usp=drive_link"
            target="_blank"
            className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors"
          >
            Terms
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
